import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddPatientService } from '../../../../services/addpatient.service';
import {
  ImageCropperComponent,
  ImageCroppedEvent,
  LoadedImage,
  ImageCropperModule,
} from 'ngx-image-cropper';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  selector: 'app-our-image-cropper',
  templateUrl: './our-image-cropper.component.html',
  styleUrls: ['./our-image-cropper.component.css'],
  standalone: true,
  imports: [ImageCropperModule, TranslateModule, FlexLayoutModule],
})
export class OurImageCropperComponent {
  @ViewChild('cropper') cropper!: ImageCropperComponent;

  croppedImage: Blob | null | undefined;
  imageChangedEvent: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OurImageCropperComponent>,
    private readonly addPatientService: AddPatientService
  ) {
    if (data && data.imageChangedEvent) {
      this.imageChangedEvent = data.imageChangedEvent;
    }
  }

  imageCroppedHandler(event: ImageCroppedEvent) {
    this.croppedImage = event.blob;
  }

  closeDialogBox() {
    this.addPatientService.setProfilePicture(null);
    this.dialogRef.close();
  }

  cropAndUploadImage() {
    this.addPatientService.setProfilePicture(this.croppedImage!);
    this.dialogRef.close();
  }
}
